var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameMega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2850_671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M104.794 -56.2237C114.012 -43.1028 122.59 -37.1334 130.933 -29.1711C139.279 -21.0763 147.393 -10.7235 152.232 2.19888C157.072 15.2538 158.771 31.009 152.173 41.8512C145.443 52.6956 130.678 58.4904 117.186 69.4378C103.696 80.5178 91.4754 96.6177 79.0147 96.9402C66.5539 97.2628 53.8546 81.9406 45.1571 68.1488C36.5942 54.4875 32.0371 42.6217 25.6399 31.8449C19.2428 21.0681 10.7405 11.3843 13.8033 3.51341C16.866 -4.35748 31.4897 -10.6806 38.3711 -20.3337C45.3851 -29.9888 44.5221 -43.1044 49.4584 -58.5629C54.3926 -74.1539 65.2587 -92.0897 75.4899 -90.787C85.8515 -89.6188 95.5762 -69.3445 104.794 -56.2237Z",
    fill: "#344157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0 -91)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameMega);
export default __webpack_public_path__ + "static/media/FrameMega.e8715368.svg";
export { ForwardRef as ReactComponent };